export default __webpack_public_path__ + "static/media/047-basketball.4528d282.svg";